import { createContext, useEffect, useState } from "react";

export const RmcContext = createContext();

const RmcProvider = ({ children }) => {
  const [triviaId, setTriviaId] = useState(() => {
    const stored = localStorage.getItem("rmc_trivia_id");
    return stored ? stored : "";
  });

  const [brandId, setBrandId] = useState(() => {
    const stored = localStorage.getItem("rmc_brand_id");
    return stored ? stored : "";
  });

  const [slug, setSlug] = useState(() => {
    const stored = localStorage.getItem("world_slug");
    return stored ? stored : "";
  });
  const [worldBranch, setWorldBranch] = useState(() => {
    const stored = localStorage.getItem("world_branch");
    return stored ? JSON.parse(stored) : "";
  });

  const [rmcAudience, setRmcAudience] = useState(() => {
    const stored = localStorage.getItem("rmc_audience");
    return stored ? JSON.parse(stored) : "";
  });

  useEffect(() => {
    if (triviaId) {
      localStorage.setItem("rmc_trivia_id", triviaId);
    }
    if (brandId) {
      localStorage.setItem("rmc_brand_id", brandId);
    }
    if (slug) {
      localStorage.setItem("world_slug", slug);
    }
    if (rmcAudience) {
      localStorage.setItem("rmc_audience", JSON.stringify(rmcAudience));
    }
    if (worldBranch) {
      localStorage.setItem("world_branch", JSON.stringify(worldBranch));
    }
  }, [triviaId, brandId, slug, rmcAudience, worldBranch]);

  return (
    <RmcContext.Provider
      value={{
        triviaId,
        setTriviaId,
        brandId,
        setBrandId,
        slug,
        setSlug,
        rmcAudience,
        setRmcAudience,
        setWorldBranch,
        worldBranch,
      }}
    >
      {children}
    </RmcContext.Provider>
  );
};

export default RmcProvider;
